import { apiClient } from './client'

import type { AchievementUnlock } from './achievements'
import type { CoachNote } from './learning'

export interface TodayPlan {
  dueReviews: number
  reviewsCompleted: number
  reviewGoal: number
  newWordsAdded: number
  newWordsGoal: number
  articlesRead: number
  articlesGoal: number
  practiceSetsCompleted: number
  practiceGoal: number
}

export interface Streak {
  currentStreak: number
  activeToday: boolean
}

export interface VocabSummary {
  total: number
  newWords: number
  learning: number
  review: number
  mastered: number
  dueToday: number
}

export interface DashboardData {
  greeting: string
  isNewUser: boolean
  todayPlan: TodayPlan
  streak: Streak
  vocabularyStats: VocabSummary
  continueLearning: ContinueLearning
  growth: GrowthData
  coachNote: CoachNote | null
}

export interface RecoveredWord {
  word: string
  correctToday: number
  wasWrongYesterday: boolean
}

export interface GrowthData {
  vocabularyCount: number
  vocabularyDelta30d: number
  wordsRefreshedToday: number
  recoveredWords: RecoveredWord[]
  latestAchievement: AchievementUnlock | null
}

export interface ContinueLearning {
  canStart: boolean
  estimatedMinutes: number
  dueCount: number
  tomorrowDueCountStub: number
  resumeSessionId: string | null
  guidedSessionCompletedToday: boolean
  ctaLabel: 'CONTINUE' | 'KEEP'
  lastCompletedSessionId: string | null
}

export const dashboardApi = {
  getDashboard: () => apiClient.get<DashboardData>('/dashboard').then((r) => r.data),
}
